import React from 'react';
import { Button } from '@availity/element';
import { colors } from '../../../static/constants/theme';

interface ButtonProps {
  variant?: 'navbar' | 'navbar-signup' | 'navbar-login' | 'outlined';
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const CustomButton: React.FC<ButtonProps> = ({ variant = 'navbar', children, onClick, disabled, ...props }) => {
  const getClassName = () => {
    switch (variant) {
      case 'navbar':
        return 'btn btn--navbar';
      case 'navbar-signup':
        return 'btn btn--signup';
      case 'navbar-login':
        return 'btn btn--login';
      case 'outlined':
        return 'btn btn--outlined';
      default:
        return '';
    }
  };

  return (
    <Button 
      className={getClassName()} 
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...(disabled && {
          backgroundColor: `${colors.accent.gray} !important`,
          cursor: 'not-allowed !important',
          opacity: 0.6,
          '&:hover': {
            backgroundColor: `${colors.accent.gray} !important`,
          }
        })
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;